export default __webpack_public_path__ + "static/media/Wristwraps of the Darkwretch.4533eae9.jpg";